<template>
  <svg width="0.5833333333333334em" height="0.4166666666666667em" viewBox="0 0 28 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable max-len -->
    <path fill="currentColor" d="M27.5794 2.82843L24.751 0L9.90069 14.8503L2.82835 7.77794L-8.07047e-05 10.6064L8.4852 19.0916C8.82393 19.4304 9.25393 19.6222 9.69603 19.6671C10.2741 19.7265 10.873 19.5348 11.3159 19.0919L27.5794 2.82843Z" />
  </svg>
</template>
